// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/curve_parameter_options.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_quanterix_common_extensions_v1_field_options } from "../../../common/extensions/v1/field_options_pb";
import type { CurveOptimizerType } from "../../../common/types/v1/curve_optimizer_type_pb";
import { file_quanterix_common_types_v1_curve_optimizer_type } from "../../../common/types/v1/curve_optimizer_type_pb";
import type { CurveType } from "../../../common/types/v1/curve_type_pb";
import { file_quanterix_common_types_v1_curve_type } from "../../../common/types/v1/curve_type_pb";
import type { CurveWeightType } from "../../../common/types/v1/curve_weight_type_pb";
import { file_quanterix_common_types_v1_curve_weight_type } from "../../../common/types/v1/curve_weight_type_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/curve_parameter_options.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_curve_parameter_options: GenFile = /*@__PURE__*/
  fileDesc("CkVxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvY3VydmVfcGFyYW1ldGVyX29wdGlvbnMucHJvdG8SJ3F1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MSKgAwoVQ3VydmVQYXJhbWV0ZXJPcHRpb25zEg8KAmlkGAEgASgJSACIAQESHAoHcGxleF9pZBgCIAEoCUIGgrUYAhgBSAGIAQESHQoIYXNzYXlfaWQYAyABKAlCBoK1GAIYAUgCiAEBEkYKE2N1cnZlX2VxdWF0aW9uX3R5cGUYBCABKA4yJC5xdWFudGVyaXguY29tbW9uLnR5cGVzLnYxLkN1cnZlVHlwZUgDiAEBEkcKDndlaWdodGluZ190eXBlGAUgASgOMioucXVhbnRlcml4LmNvbW1vbi50eXBlcy52MS5DdXJ2ZVdlaWdodFR5cGVIBIgBARJKCg5vcHRpbWl6ZXJfdHlwZRgGIAEoDjItLnF1YW50ZXJpeC5jb21tb24udHlwZXMudjEuQ3VydmVPcHRpbWl6ZXJUeXBlSAWIAQFCBQoDX2lkQgoKCF9wbGV4X2lkQgsKCV9hc3NheV9pZEIWChRfY3VydmVfZXF1YXRpb25fdHlwZUIRCg9fd2VpZ2h0aW5nX3R5cGVCEQoPX29wdGltaXplcl90eXBlYgZwcm90bzM", [file_quanterix_common_extensions_v1_field_options, file_quanterix_common_types_v1_curve_optimizer_type, file_quanterix_common_types_v1_curve_type, file_quanterix_common_types_v1_curve_weight_type]);

/**
 * Describes input parameters for evaluating a fitted curve from a dataset
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.CurveParameterOptions
 */
export type CurveParameterOptions = Message<"quanterix.simoa_one.analysis_app_api.v1.CurveParameterOptions"> & {
  /**
   * Unique identifier (UUID)
   *
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * Unique identifier (UUID) of the parent plex of this limit set
   *
   * @generated from field: optional string plex_id = 2;
   */
  plexId?: string;

  /**
   * Unique identifier (UUID) of the parent assay of this limit set
   *
   * @generated from field: optional string assay_id = 3;
   */
  assayId?: string;

  /**
   * Curve equation type (e.g. 5PL, 4PL, etc.)
   *
   * @generated from field: optional quanterix.common.types.v1.CurveType curve_equation_type = 4;
   */
  curveEquationType?: CurveType;

  /**
   * Curve weighting (e.g. 1/y^2, 1/y, unweighted etc.)
   *
   * @generated from field: optional quanterix.common.types.v1.CurveWeightType weighting_type = 5;
   */
  weightingType?: CurveWeightType;

  /**
   * Curve optimizer algorithm type
   * NOTE: In most scenarios this field should be set to DEFAULT,
   * deferring to the curve fitting implementation. Only change
   * this setting if you know what you are doing.
   *
   * @generated from field: optional quanterix.common.types.v1.CurveOptimizerType optimizer_type = 6;
   */
  optimizerType?: CurveOptimizerType;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.CurveParameterOptions.
 * Use `create(CurveParameterOptionsSchema)` to create a new message.
 */
export const CurveParameterOptionsSchema: GenMessage<CurveParameterOptions> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_curve_parameter_options, 0);

